import { CircularProgressColor, CircularProgressSize } from '../CircularProgress.types'

/**
 * Solution below seems unaesthetic.
 * In the first revision i tried code like `require(`./${color}-${size}.svg?raw`)`.
 * We need '?raw' query part to make storybook load SVGs like file instead of raw text.
 * But this approach doesn't work for esbuild. Finally I figured out that the
 * reason is in building path dynamically. The dictionary below works for both esbuild
 * and storybook.
 */

type Paths = {
  [color in CircularProgressColor]: { [size in CircularProgressSize]: string }
}

const paths: Paths = {
  brand: {
    16: require('./brand-16.svg?raw'),
    24: require('./brand-24.svg?raw'),
    32: require('./brand-32.svg?raw'),
    64: require('./brand-64.svg?raw')
  },
  default: {
    16: require('./default-16.svg?raw'),
    24: require('./default-24.svg?raw'),
    32: require('./default-32.svg?raw'),
    64: require('./default-64.svg?raw')
  },
  inverted: {
    16: require('./inverted-16.svg?raw'),
    24: require('./inverted-24.svg?raw'),
    32: require('./inverted-32.svg?raw'),
    64: require('./inverted-64.svg?raw')
  }
}

export const getFile = (color: CircularProgressColor, size: CircularProgressSize) => paths[color][size]
